'use strict';

var isAfter = require('date-fns/isAfter');
var startOfDay = require('date-fns/startOfDay');

function _interopDefault (e) { return e && e.__esModule ? e.default : e; }

var isAfter__default = /*#__PURE__*/_interopDefault(isAfter);
var startOfDay__default = /*#__PURE__*/_interopDefault(startOfDay);

function isAfterDay(...params) {
  return isAfter__default(startOfDay__default(params[0]), startOfDay__default(params[1]));
}

exports.isAfterDay = isAfterDay;
//# sourceMappingURL=isAfterDay.cjs.map
